/* eslint-disable @typescript-eslint/no-magic-numbers */
import { IsJSON, MaxLength } from "class-validator";

import "reflect-metadata";

export class GlobalConfigDto {
  id: number;

  @MaxLength(255)
  name: string;

  @IsJSON()
  value: string;
}
